/* =====================================================
   LUCIENTE INTERACTIONS — bhmanstore.com
   Clean, Minimalist JavaScript Features & Micro-Interactions
   Inspired by: https://luciente-online.com/
   ===================================================== */

(function () {
  'use strict';

  /* ── 1. Image Zoom on Product Hover ──────────────── */
  function initProductCardHovers() {
    const cards = document.querySelectorAll('.m-product-card');
    cards.forEach(card => {
      const img = card.querySelector(
        '.m-product-card__main-image img, .m-product-card__media img, .m-product-card__link img'
      );
      if (!img) return;

      card.addEventListener('mouseenter', () => {
        img.style.transform = 'scale(1.04)';
      });

      card.addEventListener('mouseleave', () => {
        img.style.transform = 'scale(1)';
      });
    });
  }

  /* ── 2. Size Guide (Scheda Taglie) Modal Trigger ─── */
  function initSizeGuideModal() {
    const triggers = document.querySelectorAll('.luc-size-guide-trigger, [data-open-size-guide]');
    const overlay = document.querySelector('#LucienteSizeGuideModal');
    if (!overlay) return;

    const closeBtn = overlay.querySelector('.luc-modal-close');

    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── 3. Subtle Scroll Reveal ──────────────────────── */
  function initScrollReveal() {
    const targets = document.querySelectorAll(
      '.m-product-card, .m-section-header, .m-collection-header, .m-index-section-header'
    );

    const style = document.createElement('style');
    style.textContent = `
      .luc-reveal {
        opacity: 0;
        transform: translateY(16px);
        transition: opacity 0.5s ease, transform 0.5s ease;
      }
      .luc-reveal.luc-visible {
        opacity: 1;
        transform: translateY(0);
      }
    `;
    document.head.appendChild(style);

    targets.forEach((el, i) => {
      el.classList.add('luc-reveal');
      el.style.transitionDelay = `${(i % 6) * 0.05}s`;
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('luc-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    targets.forEach(el => observer.observe(el));
  }

  /* ── Boot ─────────────────────────────────────────── */
  function boot() {
    initProductCardHovers();
    initSizeGuideModal();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();
